import { HelpCircle } from "lucide-react";

const SUPPORT_EMAIL = "support@inmynamekyc.co.uk";

export default function NeedHelp() {
  return (
    <a
      href={`mailto:${SUPPORT_EMAIL}`}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#4c7375] px-4 py-2.5 text-sm font-medium text-white shadow-lg transition-colors hover:bg-[#3a5a5c] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4c7375] focus-visible:ring-offset-2"
    >
      <HelpCircle className="h-4 w-4" />
      Need Help?
    </a>
  );
}
